import { Capacitor } from "@capacitor/core";

const supportedRoutes = new Set([
  "/",
  "/search",
  "/practitioners",
  "/compare",
  "/write-review",
  "/pricing",
  "/library",
  "/sign-in",
  "/claim",
]);

export const applyNativeScreenshotRoute = (): void => {
  if (!Capacitor.isNativePlatform()) return;
  const launchArguments = (window as Window & {
    process?: { argv?: string[] };
  }).process?.argv || [];
  const argumentIndex = launchArguments.indexOf("-ObserverStoreScene");
  const argumentRoute =
    argumentIndex >= 0 ? launchArguments[argumentIndex + 1] : undefined;
  const raw =
    argumentRoute ||
    new URLSearchParams(window.location.search).get("store_scene") ||
    undefined;
  if (!raw) return;

  // Store capture automation is an explicit, local simulator workflow. Keep
  // its images clean without silently making an analytics choice for users.
  try {
    localStorage.setItem("observer_analytics_consent_v1", "denied");
  } catch {
    // Storage can be unavailable in hardened WebViews; the consent dialog then
    // remains visible and the capture validator will reject the image.
  }

  const route = raw;
  const url = new URL(route, "https://observertheory.com");
  if (
    (!supportedRoutes.has(url.pathname) && !url.pathname.startsWith("/profile/")) ||
    url.origin !== "https://observertheory.com"
  ) {
    return;
  }
  window.history.replaceState({}, "", `${url.pathname}${url.search}${url.hash}`);
};
